<template>
    <div class="body">
        <div class="back" @click="$router.go(-1)">
            <img src="../../assets/img/i19.png" />
            返回
        </div>
        <div class="content">
            <div class="c_top">
                <div class="ct_title">创建课堂</div>
                <div class="ct_box">
                    <div class="ctb_item">
                        <div class="tbi_top"><span>*</span>课题名称：</div>
                        <div class="tbi_bottom">
                            <el-input type="text" placeholder="请认真填写，否则会影响智能体数据判断" v-model="courseName" maxlength="20"
                                show-word-limit></el-input>
                        </div>
                    </div>
                    <div class="ctb_item">
                        <div class="tbi_top"><span>*</span>学段名称：</div>
                        <div class="tbi_bottom">
                            <el-select v-model="sectionId" placeholder="请选择" @change="sectionChange">
                                <el-option v-for="item in sectionArr" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="ctb_item">
                        <div class="tbi_top"><span>*</span>学科名称：</div>
                        <div class="tbi_bottom">
                            <el-select v-model="subjectId" placeholder="请选择">
                                <el-option v-for="item in subjectArr" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="c_center">
                <div class="cc_box">
                    <div class="ccb_title">
                        <div class="cbt_left">待选择</div>
                        <div class="cbt_right">
                            <div :class="type == 1 ? 'ltr' : ''" @click="btn_type(1)">官方</div>
                            <div :class="type == 2 ? 'ltr' : ''" @click="btn_type(2)">个人</div>
                        </div>
                    </div>
                    <div class="ccb_box">
                        <div class="cbb_item" v-for="(item, index) in filteredAvailableItems" :key="index"
                            @click="btn_item(item, index)">
                            <img class="bbi_left"
                                :src="item.select == 0 ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
                            <div class="bbi_right">
                                <img class="bir_left" :src="webImg + item.icon" />
                                <div class="bir_right">
                                    <div>{{ item.helperName }}</div>
                                    <div>{{ item.note }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cc_box">
                    <div class="ccb_title">已选择</div>
                    <div class="ccb_box">
                        <div class="cbb_item" :class="item.flag == 1 ? 'cbbi' : ''"
                            v-for="(item, index) in selectedItems" :key="index" @click="btn_sItem(item, index)"
                            style="border: 1px solid #ECECEC;border-radius: 18px;padding: 14px;">
                            <div class="bbi_right" style="margin-left: 0;">
                                <img class="bir_left" :src="webImg + item.icon" />
                                <div class="bir_right1">
                                    <div class="rr1_left">
                                        <div>{{ item.helperName }}</div>
                                        <div>{{ item.note }}</div>
                                    </div>
                                    <div class="rr1_right" :class="item.filled || item.id ? 'rr1r' : ''"
                                        v-if="item.show && item.type != 4">
                                        {{ item.filled ? '已填写' : '未填写' }}
                                    </div>
                                    <div class="rr1_right" :class="item.questionGroupId ? 'rr1r' : ''"
                                        v-if="item.type == 4">
                                        {{ item.questionGroupId ? '已选择' : '未选择' }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cc_box">
                    <div class="ccb_title" v-if="zntInfo && zntInfo.type == 4">
                        <div class="cbt_left">选择题库</div>
                        <el-button type="primary" size="small" style="position: absolute;right:18px;"
                            @click="$router.push('/questionBankManage')">添加题库</el-button>
                    </div>
                    <div class="ccb_box">
                        <div class="c_bottom" v-if="templateList.length == 0 && (zntInfo && zntInfo.type == 4)">
                            <div class="cb_tk" v-for="(item, index) in list" :key="index"
                                @click="btn_tkItem(item, index)">
                                <img class="tk_left"
                                    :src="item.select == 0 ? require('@/assets/img/i14.png') : require('@/assets/img/i15.png')" />
                                <div class="tk_right">题库：{{ item.groupName }}</div>
                            </div>
                            <el-empty description="暂无题库数据" v-if="list.length == 0"></el-empty>
                        </div>
                        <div class="c_bottom" v-if="templateList.length > 0">
                            <div class="cb_item" v-for="(item, index) in templateList" :key="index"
                                v-if="item.attrName">
                                <div class="cbi_top"><span>*</span>{{ item.attrName }}</div>
                                <div class="cbi_bottom1">
                                    <el-select v-model="item.selectName" placeholder="请选择"
                                        @change="oneChange($event, index)">
                                        <el-option v-for="(itemA, indexA) in item.attrValues" :key="indexA"
                                            :value="itemA"></el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="cb_item" v-for="(item, index) in templateList" :key="index"
                                v-if="!item.attrName">
                                <div class="cbi_top"><span v-if="item.requiredFlag == 1">*</span>{{ item.title }}</div>
                                <div class="cbi_bottom" v-if="item.type != 2">
                                    <input maxlength="5000" placeholder="请输入" v-model="item.text" v-if="item.type == 0"
                                        @input="inputChange($event, index)" />
                                    <textarea maxlength="5000" placeholder="请输入" v-model="item.text"
                                        v-if="item.type == 1" @input="inputChange($event, index)"></textarea>
                                </div>
                                <div class="cbi_bottom1" v-if="item.type == 2">
                                    <el-select v-model="item.text" placeholder="请选择" @change="twoChange($event, index)">
                                        <el-option v-for="(itemA, indexA) in item.opt" :key="indexA"
                                            :value="itemA"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn_box">
                <div class="btn1" @click="submit" v-if="!ktId">创建</div>
                <div class="btn1" @click="submit" v-if="ktId">保存</div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    classInfo,
    checkPermi,
    classStudentList,
    classCourseList,
    courseAdd,
    techHelperOption,
    courseDetail,
    courseEdit,
    courseRemove,
    helperInfo,
    nextPromptOption,
    promptInfo,
    sectionSubject,
    questionGroupList,
    userInfo
} from '@/apis/index'
export default {
    data() {
        return {
            availableItems: [],//可添加的项目列表
            selectedItems: [],//已添加的项目列表
            courseType: this.$route.query.courseType,
            ktId: this.$route.query.id,
            techClassId: this.$route.query.techClassId,
            type: 1,
            helperObj: {},
            templateList: [],
            prompts: '',
            sIndex: null,
            courseName: this.$route.query.courseName || '',
            sectionArr: [],
            sectionId: '',
            subjectArr: [],
            subjectId: '',
            pageNum: 1,
            pageSize: 20,
            total: 0,
            list: [],
            zntInfo: {}
        }
    },
    computed: {
        // 新增过滤条件：根据type筛选且排除已选数据
        filteredAvailableItems() {
            return this.availableItems.filter(item => {
                const typeMatch = this.type == 1 ? item.isPersonal == null : item.isPersonal != null
                return typeMatch
            })
        }
    },
    created() {
        if (this.$route.query.id) {

        }
    },
    mounted() {
        this.getTechHelperOption()
        this.getSectionSubject()
    },
    methods: {
        getSectionSubject() {
            sectionSubject(2).then(res => {
                console.log(res, 'sectionSubject');
                userInfo().then(resA => {
                    console.log(resA, 'userInfo')
                    this.sectionArr = res.data
                    this.sectionId = resA.data.techSectionId
                    this.subjectId = ''
                    this.subjectArr = []
                    this.subjectArr = this.sectionArr.find(item => item.id == this.sectionId).subjectList
                })
            })
        },
        btn_tkItem(item, index) {
            console.log(item,'item');

            // 取消所有选中状态
            this.list.forEach(i => {
                i.select = 0;
            });

            // 设置当前点击项为选中
            item.select = 1;
            this.selectedItems[this.sIndex].questionGroupId = item.id
        },
        getList() {
            questionGroupList(this.pageNum, this.pageSize).then(res => {
                console.log(res, 'questionGroupList');
                if (this.pageNum == 1) {
                    this.list = []
                }
                res.data.list.forEach(item => { item.select = 0 })
                this.total = res.data.total
                this.list = res.data.list
            })
        },
        // 学段变化事件
        sectionChange(e) {
            this.subjectId = ''
            this.subjectArr = []
            console.log(e, 'e', this.sectionArr.find(item => item.id == e));
            this.subjectArr = this.sectionArr.find(item => item.id == e).subjectList
        },
        // getSectionSubject() {
        //     sectionSubject(2).then(res => {
        //         console.log(res, 'sectionSubject');
        //         this.sectionArr = res.data
        //     })
        // },
        textReplace(templateList) {
            // 创建一个新的 Map
            const dataMap = new Map();
            // 使用 forEach 方法填充 Map
            templateList.forEach(obj => {
                console.log(obj, 'obj');
                if (obj.title) {
                    dataMap.set(obj.title, obj.text);
                } else {
                    dataMap.set(obj.attrName, obj.selectName);
                }
            });
            console.log(dataMap, 'dataMap');
            // 替换字符串中的占位符
            return this.prompts.replace(/{(.*?)}/g, (match, key) => {
                console.log(dataMap.get(key) || match, 'ssssss');
                return dataMap.get(key) || ''; // 如果找不到对应的值，则保留原始占位符
            });
            console.log(this.prompts, 'prompts');
        },
        submit() {
            this.throttle(() => {
                if (this.courseName == '') {
                    this.$message({
                        message: '请输入课题名称',
                        type: 'warning'
                    });
                    return
                }
                if (this.sectionId == '') {
                    this.$message({
                        message: '请选择学段',
                        type: 'warning'
                    });
                    return
                }
                if (this.subjectId == '') {
                    this.$message({
                        message: '请选择学科',
                        type: 'warning'
                    });
                    return
                }
                if (this.selectedItems.length == 0) {
                    this.$message({
                        message: '请选择智能体',
                        type: 'warning'
                    });
                    return
                }
                // 新增校验：如果selectedItems中包含type为4的智能体，必须选择题库
                const hasQuestionHelper = this.selectedItems.some(item => item.type == 4);
                if (hasQuestionHelper) {
                    const notSelectedGroup = this.selectedItems.some(item => item.type == 4 && !item.questionGroupId);
                    if (notSelectedGroup) {
                        this.$message({
                            message: '包含出题助手的智能体必须选择题库',
                            type: 'warning'
                        });
                        return;
                    }
                }
                console.log(this.selectedItems, 'selectedItems');
                this.selectedItems.forEach(item => {
                    item.ifChoose = true
                    if (!item.id) {
                        if (item.workflowId) {
                            console.log(item, 'items');
                            if (item.templateList && item.templateList.length > 0) {
                                item.templateList.forEach((itemA, indexA) => {
                                    itemA.attrValue = itemA.selectName
                                    if (indexA == item.templateList.length - 1) {
                                        item.prompt = JSON.stringify(item.templateList)
                                    }
                                })
                            }
                        } else {
                            if (item.templateList && item.templateList.length > 0) {
                                item.prompt = this.textReplace(item.templateList)
                            }
                        }
                    }
                })
                console.log(this.selectedItems, 'lists');
                let loading = this.$loading({
                    lock: true,
                    text: "正在保存中，请稍候...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                if (this.ktId) {
                    courseEdit({
                        techClassHelperList: this.selectedItems,
                        courseName: this.courseName,
                        sectionId: this.sectionId,
                        subjectId: this.subjectId,
                        techClassId: this.techClassId,
                        id: this.ktId,
                        courseType: this.courseType
                    }).then(res => {
                        console.log(res, 'res');
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.$router.replace({ path: '/classroomInfo', query: { id: this.ktId } });
                    }).finally(() => {
                        loading.close();
                    })
                } else {
                    courseAdd({
                        techClassHelperList: this.selectedItems,
                        courseName: this.courseName,
                        sectionId: this.sectionId,
                        subjectId: this.subjectId,
                        techClassId: this.techClassId,
                        courseType: this.courseType
                    }).then(res => {
                        console.log(res, 'res');
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        this.$router.replace({ path: '/classroomInfo', query: { id: res.data } });
                    }).finally(() => {
                        loading.close();
                    })
                }
            })
        },
        inputChange(e, index) {
            console.log(this.templateList, 'templateList');
            if (this.templateList.length - 1 == index) {
                if (this.templateList[index].text.trim() == '') {
                    this.selectedItems[this.sIndex].filled = false
                } else {
                    this.selectedItems[this.sIndex].filled = true
                    this.selectedItems[this.sIndex].templateList = this.templateList
                }
            }
            this.$forceUpdate()
        },
        twoChange(e, index) {
            console.log(e, 'twoChange', index);
            console.log(this.templateList, 'templateList2');
            this.templateList[index].text = e
            if (this.templateList.length - 1 == index) {
                this.selectedItems[this.sIndex].filled = true
                this.selectedItems[this.sIndex].templateList = this.templateList
            }
            this.$forceUpdate()
        },
        oneChange(e, index) {
            console.log(e, 'oneChange', index);
            this.templateList[index].selectName = e
            var list = []
            this.templateList.forEach(itemA => {
                if (itemA.selectName) {
                    const newObj = {
                        [itemA.attrName]: itemA.selectName
                    };
                    list.push(newObj)
                }
            })

            const result = list.reduce((accumulator, current) => {
                return {
                    ...accumulator,
                    ...current
                };
            }, {});

            if (this.templateList[index + 1] && this.templateList[index + 1].attrName) {
                nextPromptOption({
                    helperId: this.helperObj.id,
                    attrValue: JSON.stringify(result)
                }).then(res => {
                    console.log(res, 'nextPromptOption');
                    this.templateList[index + 1].attrValues = res.data
                })
            }

            var templateList = this.templateList.filter(item => item.attrName)
            if (templateList.length !== list.length) {
                return
            }

            promptInfo({
                helperId: this.helperObj.id,
                attrValue: JSON.stringify(result)
            }).then(res => {
                this.prompts = res.data.prompt
                this.templateList = this.templateList.filter((itemA) => {
                    console.log(itemA, 'itemA');
                    return itemA.attrName;
                });
                res.data.promptList.forEach(itemB => {
                    itemB.text = ''
                })
                this.templateList = [...this.templateList, ...res.data.promptList]
                if (this.templateList.length - 1 == index) {
                    this.selectedItems[this.sIndex].filled = true
                    this.selectedItems[this.sIndex].templateList = this.templateList
                }
                this.$forceUpdate()
            })
        },
        btn_sItem(item, index) {
            console.log(item, 'sitem');
            if (item.id) {
                return this.$message.warning('已创建成功的智能体不可修改')
            }
            // 切换当前item的flag
            item.flag = item.flag == 0 ? 1 : 0;
            if (item.flag == 1 && !item.createBy) {
                this.sIndex = index;
                this.selectedItems.forEach((it, idx) => {
                    if (idx != index) {
                        it.flag = 0
                    }
                });
                this.templateList = []
                // this.list = []
                this.getHelperInfo(item.techHelperId, data => {
                    console.log(data, 'datasss');
                    this.zntInfo = data
                    // if (data.type == 4) {
                    //     this.getList()
                    // }
                    if (this.templateList.length > 0) {
                        item.show = true
                    } else {
                        item.show = false
                    }
                });
            }
        },
        getHelperInfo(techHelperId, fun) {
            helperInfo(techHelperId).then(res => {
                console.log(res, 'helperInfo');
                this.helperObj = res.data
                if (this.helperObj.extraAttrFlag == 0) {
                    this.helperObj.promptList.forEach(itemB => {
                        itemB.text = ''
                        if (itemB.opt) {
                            itemB.opt = itemB.opt.split(',')
                        }
                    })
                    this.templateList = this.helperObj.promptList
                    this.prompts = this.helperObj.prompt
                } else {
                    this.helperObj.attrList.forEach(itemB => {
                        itemB.text = ''
                    })
                    this.templateList = this.helperObj.attrList
                    this.templateList.forEach(e => {
                        if (e.attrValues) {
                            e.selectName = ''
                            e.attrValues = e.attrValues.split(',')
                        }
                    })
                    this.prompts = this.helperObj.prompt
                }
                fun(res.data)
            })
        },
        btn_type(type) {
            this.type = type
        },
        btn_item(item, index) {
            console.log(item, 'item');
            if (item.id) {
                return this.$message.warning('已创建成功的智能体不可修改')
            }
            item.select = item.select == 0 ? 1 : 0
            if (item.select == 1) {
                // select变成1，加入selectedItems（避免重复加入）
                if (!this.selectedItems.some(selected => selected.techHelperId == item.techHelperId)) {
                    this.templateList = []
                    this.getHelperInfo(item.techHelperId, data => {
                        console.log(data, 'datasss');
                        this.selectedItems.push({ ...item, flag: 0, workflowId: item.workflowId, show: this.templateList.length > 0 ? true : false, type: data.type });
                        if (!this.selectedItems[this.selectedItems.length - 1].prompt) {
                            this.selectedItems[this.selectedItems.length - 1].prompt = data.prompt
                        }
                        this.selectedItems[this.selectedItems.length - 1].flag = 1
                        this.sIndex = this.selectedItems.length - 1
                        this.selectedItems.forEach((it, idx) => {
                            if (idx != this.selectedItems.length - 1) {
                                it.flag = 0
                            }
                        });
                        if (this.selectedItems[this.selectedItems.length - 1].flag == 1 && !this.selectedItems[this.selectedItems.length - 1].createBy) {
                            this.getHelperInfo(this.selectedItems[this.selectedItems.length - 1].techHelperId, data => {
                                console.log(data, 'datasss');
                                this.zntInfo = data

                                if (data.type == 4) {
                                    this.getList()
                                }
                                if (this.templateList.length > 0) {
                                    this.selectedItems[this.selectedItems.length - 1].show = true
                                } else {
                                    this.selectedItems[this.selectedItems.length - 1].show = false
                                }
                            });
                        }
                        console.log(this.selectedItems, 'selectedItems');
                    });
                }
            } else {
                // select变成0，从selectedItems中移除
                this.selectedItems = this.selectedItems.filter(selected => selected.techHelperId != item.techHelperId);
            }
        },
        // 获取课堂智能体接口
        getTechHelperOption() {
            // createBy空的就是官方的智能体
            techHelperOption(this.courseType, this.ktId).then(res => {
                console.log(res, 'techHelperOption');
                res.data.forEach(item => {
                    item.select = 0
                    if (item.ifChoose) {
                        this.selectedItems.push(item)
                    }
                })
                this.availableItems = res.data
            });
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep {
    .el-select {
        width: 100% !important;
    }
}

.body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;

    .back {
        width: 100%;
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 14px;
        color: #000000;
        margin-bottom: 10px;
        margin-top: 10px;
        cursor: pointer;
        box-sizing: border-box;
        padding: 20px 30px;

        img {
            width: 14px;
            height: 14px;

        }
    }

    .content {
        width: 1200px;
        height: 0;
        flex: 1;
        display: flex;
        flex-direction: column;

        .c_top {
            width: 100%;

            .ct_title {
                width: 100%;
                font-weight: bold;
                font-size: 18px;
                color: #000000;
            }

            .ct_box {
                width: 100%;
                display: flex;
                align-items: center;
                flex-wrap: wrap;

                .ctb_item:nth-child(3n) {
                    margin-right: 0 !important;
                }

                .ctb_item {
                    width: 370px;
                    margin-top: 15px;
                    margin-right: 15px;

                    .tbi_top {
                        width: 100%;
                        font-weight: bold;
                        font-size: 14px;
                        color: #252525;

                        span {
                            font-weight: 500;
                            font-size: 14px;
                            color: #FF0000;
                        }
                    }

                    .tbi_bottom {
                        width: 100%;
                        margin-top: 10px;
                    }
                }
            }
        }

        .c_center {
            width: 100%;
            height: 0;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 35px;

            .cc_box {
                width: 380px;
                height: 100%;
                border-radius: 7px 7px 7px 7px;
                border: 1px solid #F0F0F0;
                display: flex;
                flex-direction: column;
                margin-bottom: 30px;

                .ccb_title {
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;
                    padding: 18px;
                    border-bottom: 1px solid #ECECEC;
                    margin-bottom: 25px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    position: relative;

                    .cbt_right {
                        width: 110px;
                        height: 25px;
                        border: 1px solid#9EA3A7;
                        border-radius: 8px 8px 8px 8px;
                        display: flex;
                        align-items: center;
                        overflow: hidden;

                        .ltr {
                            background-color: #399AFF !important;
                            color: #fff !important;
                        }

                        div {
                            flex: 1;
                            height: 100%;
                            line-height: 25px;
                            text-align: center;
                            font-weight: 400;
                            font-size: 12px;
                            color: #333333;
                            cursor: pointer;
                        }
                    }
                }

                // .ccb_box::-webkit-scrollbar {
                //     display: none;
                // }
                .ccb_box {
                    width: 100%;
                    height: 0;
                    flex: 1;
                    overflow-y: scroll;
                    box-sizing: border-box;
                    padding: 0 18px;

                    .c_bottom {
                        height: 100%;
                        // width: 65%;
                        box-sizing: border-box;

                        .cb_tk {
                            width: 100%;
                            display: flex;
                            align-items: center;
                            margin-top: 15px;
                            cursor: pointer;

                            .tk_left {
                                width: 14px;
                                height: 14px;
                            }

                            .tk_right {
                                margin-left: 7px;
                                font-weight: 500;
                                font-size: 14px;
                                color: #000000;
                            }
                        }

                        .cb_item {
                            width: 100%;
                            margin-top: 40px;

                            .cbi_top {
                                width: 100%;
                                font-weight: bold;
                                font-size: 16px;
                                color: #252525;

                                span {
                                    font-weight: 500;
                                    font-size: 16px;
                                    color: #FF0000;
                                    margin-right: 5px;
                                }
                            }

                            .cbi_bottom1 {
                                width: 100%;
                                margin-top: 10px;

                                .el-select {
                                    width: 100%;
                                }
                            }

                            .cbi_bottom {
                                width: 100%;
                                margin-top: 10px;

                                input {
                                    width: 100%;
                                    height: 40px;
                                    background: #FFFFFF;
                                    border-radius: 2px 2px 2px 2px;
                                    border: 1px solid #E2E6ED;
                                    box-sizing: border-box;
                                    padding: 0 10px;
                                    font-weight: 500;
                                    font-size: 14px;
                                }

                                textarea {
                                    width: 100%;
                                    height: 100px;
                                    background: #FFFFFF;
                                    border-radius: 2px 2px 2px 2px;
                                    border: 1px solid #E2E6ED;
                                    box-sizing: border-box;
                                    padding: 10px;
                                    font-weight: 500;
                                    font-size: 14px;
                                }
                            }
                        }
                    }

                    .cbbi {
                        border: 1px solid #2992FF !important;
                    }

                    .cbb_item {
                        // width: 100%;
                        display: flex;
                        align-items: center;
                        margin-bottom: 15px;
                        cursor: pointer;

                        .bbi_left {
                            width: 14px;
                            height: 14px;
                        }

                        .bbi_right {
                            flex: 1;
                            margin-left: 14px;
                            display: flex;
                            align-items: center;

                            .bir_left {
                                width: 36px;
                                height: 36px;
                                border-radius: 4px;
                            }

                            .bir_right1 {
                                flex: 1;
                                margin-left: 7px;
                                display: flex;
                                align-items: center;

                                .rr1_left {
                                    flex: 1;
                                    margin-right: 10px;

                                    div:nth-child(1) {
                                        font-weight: 500;
                                        font-size: 14px;
                                        color: #000000;
                                    }

                                    div:nth-child(2) {
                                        font-weight: 500;
                                        font-size: 11px;
                                        color: #999999;
                                        margin-top: 7px;
                                    }
                                }

                                .rr1r {
                                    color: #2992FF !important;
                                }

                                .rr1_right {
                                    font-weight: 500;
                                    font-size: 14px;
                                    color: #999999;
                                }
                            }

                            .bir_right {
                                flex: 1;
                                margin-left: 7px;

                                div:nth-child(1) {
                                    font-weight: 500;
                                    font-size: 14px;
                                    color: #000000;
                                }

                                div:nth-child(2) {
                                    font-weight: 500;
                                    font-size: 11px;
                                    color: #999999;
                                    margin-top: 7px;
                                }

                            }
                        }
                    }
                }
            }
        }

        .btn_box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;

            .btn1 {
                width: 164px;
                height: 40px;
                background: #399AFF;
                border-radius: 8px 8px 8px 8px;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                text-align: center;
                line-height: 40px;
                margin: 0 7px;
                cursor: pointer;
            }
        }
    }
}
</style>
